module.exports = __webpack_public_path__ + "static/media/RC.2f19b691.png";